@if (cartridgeSelectableRoles().length) {
  <div class="cartridge-roles-assignment-container">
    <markant-searchbar
      [placeholder]="'common.search' | transloco"
      [debounce]="300"
      (valueChange)="onRoleSearchChange($event.detail)"
    >
    </markant-searchbar>

    <div class="cartridge-roles-container">
      <div class="cartridge-roles-list-container">
        <h5>
          {{
            'organization.users.invite.cartridgeView.servicePermissionsHeader'
              | transloco
          }}
        </h5>
        <div class="markant-card-container" markantPlatformScrollIndicator>
          @for (
            cartridgeRoles of filteredCartridgeSelectableRoles();
            track cartridgeRoles.id
          ) {
            <markant-platform-ui-cartridge-roles-assignment-card
              [isRoleLimitEnabled]="isRoleLimitEnabled"
              [cartridgeRoles]="cartridgeRoles"
              [flow]="CartridgeRoleAssignmentFlow.Add"
              (roleAdded)="onAddRole($event)"
            >
            </markant-platform-ui-cartridge-roles-assignment-card>
          }
        </div>
      </div>

      <markant-seperator
        class="cartridge-roles-vertical-separator cartridge-roles-separator"
        orientation="vertical"
      ></markant-seperator>

      <markant-seperator
        class="cartridge-roles-horizontal-separator cartridge-roles-separator"
        orientation="horizontal"
      ></markant-seperator>

      <div class="cartridge-roles-list-container">
        <div class="cartridge-roles-preview-header">
          <h5>
            {{
              'organization.users.invite.cartridgeView.assignedServicePermissionsHeader'
                | transloco
            }}
          </h5>

          <markant-button
            *ngIf="selectedRoles().length"
            colorScheme="primary"
            variant="clear"
            data-cy="delete-all-roles-button"
            (keyup)="onDeleteAllRolesClick()"
            (click)="onDeleteAllRolesClick()"
          >
            <markant-icon class="icon" icon="m_close-small" slot="icon-leading">
            </markant-icon>
            {{
              'organization.users.invite.cartridgeView.removeAll' | transloco
            }}
          </markant-button>
        </div>
        <div class="markant-card-container" markantPlatformScrollIndicator>
          @if (selectedRoles().length) {
            @for (
              selectedCartridgeRoles of selectedRoles();
              track selectedCartridgeRoles.id
            ) {
              <markant-platform-ui-cartridge-roles-assignment-card
                [isRoleLimitEnabled]="isRoleLimitEnabled"
                [cartridgeRoles]="selectedCartridgeRoles"
                [flow]="CartridgeRoleAssignmentFlow.Preview"
                [hasSuborganizations]="hasSuborganizations()"
                (roleRemoved)="onDeleteRole($event)"
                (suborganizationEdit)="onSubOrganizationEditForRole($event)"
              >
              </markant-platform-ui-cartridge-roles-assignment-card>
            }
          } @else {
            <div class="no-selected-roles-label-container">
              <h5
                class="no-selected-roles-label"
                [innerHTML]="
                  'cartridge.roles.assignment.addServicePermissions' | transloco
                "
              ></h5>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if (editRoleSuborganizationAssignments && isEditSuborganizationDialogOpen) {
    <markant-platform-cartridge-role-edit-suborganizations-dialog
      [isDialogOpen]="isEditSuborganizationDialogOpen"
      [editRoleSuborganizationAssignments]="editRoleSuborganizationAssignments"
      [groupName]="groupName"
      (subOrganizationsSubmitted)="onRoleSubOrganizationsChange($event)"
      (cancel)="onCancelEditSuborganizations()"
    ></markant-platform-cartridge-role-edit-suborganizations-dialog>
  }
} @else if (isLoading) {
  <div class="cartridge-roles-empty-state">
    <markant-spinner modal="false" type="tile" colorScheme="primary">
    </markant-spinner>
  </div>
} @else {
  <div class="cartridge-roles-empty-state">
    <h4>
      {{ 'cartridge.roles.assignment.noServicesBookedYet' | transloco }}
    </h4>
  </div>
}
